import { render, staticRenderFns } from "./taxa.vue?vue&type=template&id=31881e9f&scoped=true"
import script from "./taxa.vue?vue&type=script&lang=js"
export * from "./taxa.vue?vue&type=script&lang=js"
import style0 from "./taxa.vue?vue&type=style&index=0&id=31881e9f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31881e9f",
  null
  
)

export default component.exports